import React from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { SUPPORT_EMAIL } from '../../util/supportEmail';
import { Heading, Button } from '../../components';

import css from './SystemErrorSection.module.css';

/**
 * Shared "something went wrong" UI. Used both as the content of a full
 * SystemErrorPage (route-level render crash) and embedded inline in a
 * container that hit a genuine (non-404) data-loading error - e.g. a
 * transient 5xx from the marketplace API. Never redirects: a system error
 * must look like a system error, not like the page silently succeeded.
 */
const SystemErrorSection = props => {
  const { rootClassName, className, contextLabel, onRetry } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <Heading as="h1" rootClassName={css.heading}>
        <FormattedMessage id="SystemErrorSection.heading" />
      </Heading>
      <p className={css.description}>
        {contextLabel ? (
          <FormattedMessage
            id="SystemErrorSection.descriptionWithContext"
            values={{ context: contextLabel }}
          />
        ) : (
          <FormattedMessage id="SystemErrorSection.description" />
        )}
      </p>
      <div className={css.actions}>
        {onRetry ? (
          <Button rootClassName={css.retryButton} onClick={onRetry}>
            <FormattedMessage id="SystemErrorSection.tryAgain" />
          </Button>
        ) : null}
        <a className={css.contactButton} href={`mailto:${SUPPORT_EMAIL}`}>
          <FormattedMessage id="SystemErrorSection.contactSupport" />
        </a>
      </div>
    </div>
  );
};

SystemErrorSection.defaultProps = {
  rootClassName: null,
  className: null,
  contextLabel: null,
  onRetry: null,
};

SystemErrorSection.propTypes = {
  rootClassName: string,
  className: string,
  contextLabel: string,
  onRetry: func,
};

export default SystemErrorSection;
